import React from 'react';

import classes from './ProgramProgressTopbarPM.module.css';

import Button from '../../UI/Button/Button';

const ProgramProgressTopbarPM = (props) => {

    return (
        <div className={classes.ProgramProgressTopbarPM}>
            {
                props.showButton === true
                    ? <>
                        <span></span> {/* Empty span to align items properly */}
                        <h4 className={classes.ProgramName}>
                            {props.name}
                        </h4>
                        <Button
                            label={props.label}
                            margin="0px"
                            clicked={props.clicked}
                        />
                        <span></span> {/* Empty span to align items properly */}
                    </>
                    : <>
                        <p className={classes.BatchCode}>
                            {props.batchCode}
                        </p>
                        <h4 className={classes.ProgramName}>
                            {props.name}
                        </h4>
                        <div className={[classes.ProgresBarDiv, props.hideProgress === true ? classes.Hide : ''].join(' ')} >
                            {/* <div className={classes.ProgressContainer}>
                                <span className={classes.ProgressBar}
                                    style={{ 'width': props.progress + "%" }} ></span>
                            </div>
                            <p className={classes.PercentText}>{props.progress}<span>%</span></p> */}
                        </div>
                    </>
            }
        </div>
    );
}

export default ProgramProgressTopbarPM;